import { Loading } from 'utilsModule/components';

const withLoading = ({ name = 'data' } = {}) => ComposedComponent => props => (
  props[name].status.loading ? <Loading /> : <ComposedComponent {...props} />
);

export default withLoading;
